import React from 'react';
import PropTypes from 'prop-types';
import {Navigate} from 'react-router-dom';
import _ from 'lodash';

import Forbidden from '@/page/component/AuthRoute/Forbidden';
import {useMenuService} from '@/app/wrapper/menuService';
import moduleMenus from '@/app/RouteConfig/menu';

export default function AppRedirect({menuKey}) {
    const menus = useMenuService(moduleMenus, menuKey);

    if (_.isEmpty(menus)) {
        return <Forbidden />;
    }

    // 存在菜单项则跳转
    return <Navigate to={menus[0].path} />;
}

AppRedirect.propTypes = {
    menuKey: PropTypes.string.isRequired,
};
